module.exports = __webpack_public_path__ + "img/waitHover.2932f4c3.svg";